export const UPDATE_PUBLIC = 'UPDATE_PUBLIC';
export const SET_MAINTENANCE = 'SET_MAINTENANCE';
export const SET_IS_READY = 'SET_IS_READY';
export const SET_HP_SLIDES = 'SET_HP_SLIDES';
export const SET_HAS_SHOWN_ALERTS = 'SET_HAS_SHOWN_ALERTS';
export const SET_IS_404 = 'SET_IS_404';
